export default __webpack_public_path__ + "static/media/hero_7.85580ae8.png";